import type { TranslationInterface } from '.';

export const SpanishLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Escribe un mensaje...',
  your_issue_has_been_resolved: '¡Tu problema fue resuelto!',
  new_conversation: 'Nueva conversación',
  welcome_screen_title: 'Bienvenido a nuestro chat de soporte',
  welcome_screen_description:
    '¡Estamos aquí para ayudarte! Inicia una conversación y responderemos lo antes posible.',
  your_name_placeholder: 'Tu nombre',
  your_email_placeholder: 'Tu correo electrónico',
  start_chat_button: 'Hablar con soporte',
  start_chat_button_loading: 'Conectando...',
  i_need_more_help: 'Necesito más ayuda',
  this_was_helpful: 'Esto fue útil',
  optional: 'Opcional',
  no_conversations_yet: 'Sin conversaciones aún',
  back_to_conversations: 'Volver a conversaciones',
  closed_conversations: 'Conversaciones cerradas',
  csat_title: '¿Qué tal fue tu conversación?',
  csat_submitted_title: 'Valoraste la conversación como',
  csat_feedback_placeholder: 'Cuéntanos más... (opcional)',
  follow_up_placeholder: 'Continuar…',
  companion_layout_label: 'Diseño',
  companion_layout_floating: 'Flotante',
  companion_layout_sidebar: 'Barra lateral',
  companion_layout_fullscreen: 'Pantalla completa',
  companion_close: 'Cerrar',
  companion_history: 'Historial de conversaciones',
  companion_expand_chat: 'Ampliar chat',
  companion_sidebar_dock_label: 'Acople',
  companion_sidebar_side_label: 'Lado',
  companion_sidebar_left: 'Izquierda',
  companion_sidebar_right: 'Derecha',
  companion_resize_chat: 'Cambiar el tamaño del chat',
  scroll_to_bottom: 'Desplazarse al final',
  thinking: 'Pensando…',
  running: 'En curso…',
  steps: 'pasos',
  step_arguments: 'Argumentos',
  step_result: 'Resultado',
  attach_files:
    'Adjuntar imágenes, vídeos, PDF u hojas de cálculo (tamaño máximo 25 MB)',
  mark_page_active:
    'Haz clic en cualquier elemento de la página para marcarlo — Esc para cancelar',
  mark_page: 'Marca algo de la página para preguntar sobre ello',
  stop_response: 'Detener respuesta',
  copy_reply: 'Copiar respuesta',
  mentions_empty: 'Sin coincidencias',
  copied: 'Copiado',
  send_message: 'Enviar mensaje',
  upload_failed: 'Error al subir: {error}',
  remove_attachment: 'Quitar archivo adjunto',
  json_no_items: 'No hay elementos',
  json_no_data: 'No hay datos',
  json_no_chart_data: 'No hay datos para el gráfico',
  json_unsupported: 'No compatible: {type}',
  json_see_less: 'Ver menos',
  json_phone_agent: 'Agente telefónico',
  json_phone_agent_test: 'Probar en la web',
  page_context_remove: 'Quitar el contexto de la página',
  json_see_more: 'Ver {count} más',
  queued_label: '{count} En cola',
  remove_queued_message: 'Quitar mensaje de la cola',
  send_queued_now: 'Enviar los mensajes en cola ahora',
  turn_failed_message: 'Algo salió mal y la respuesta no llegó.',
  turn_failed_retry: 'Intentar de nuevo',
  page_mark_hint: 'Haz clic en algo para marcarlo',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Recuadro',
  page_mark_shape_circle: 'Círculo',
  page_mark_shape_arrow: 'Flecha',
  page_mark_shape_bracket: 'Corchete',
  page_mark_shape_underline: 'Subrayado',
  page_mark_shape_highlight: 'Resaltado',
  page_mark_shape_strike_through: 'Tachado',
  page_mark_shape_crossed_off: 'Tachado en cruz',
  page_mark_shape_aria: 'Forma de la marca: {shape}',
  page_mark_note_placeholder: 'Añade una nota… (Enter para adjuntar)',
  page_mark_attach: 'Adjuntar marca',
  page_mark_remove: 'Quitar {label}',
  page_mark_region: 'Región marcada',
  page_mark_default_message: '¿Qué es esto?',
  file_rejected:
    'El tipo de archivo no es compatible o el archivo es demasiado grande.',
  dictate: 'Dictar',
  stop_dictation: 'Detener dictado',
  dictation_mic_blocked: 'Permite el acceso al micrófono para dictar',
  dictation_unavailable: 'El dictado no está disponible ahora mismo',
  questions_back: 'Atrás',
  questions_next: 'Siguiente',
  questions_send: 'Enviar',
  questions_type_answer: 'Lo escribo yo',
  questions_answer_placeholder: 'Escribe tu respuesta…',
  close_conversation_title: 'Cerrar conversación',
  close_conversation_description:
    '¿Seguro que quieres cerrar esta conversación?',
  close_conversation_cancel: 'No',
  close_conversation_confirm: 'Sí',
  dialog_close: 'Cerrar',
  zoom_in: 'Acercar',
  zoom_out: 'Alejar',
  reset_zoom: 'Restablecer zoom',
  support_chat_aria_label: 'Chat de soporte',
};
